import { render, staticRenderFns } from "./FinalizacaoDetalheAprovacaoJustificada.vue?vue&type=template&id=75195151"
import script from "./FinalizacaoDetalheAprovacaoJustificada.vue?vue&type=script&lang=js"
export * from "./FinalizacaoDetalheAprovacaoJustificada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports